'use client';

import React, { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';

const CostCategorySummaryGrid = () => {
  const [rowData, setRowData] = useState([
    {
      account: '141-01-1001',
      category: 'Survey, Title, ROW',
      description: 'ROW Lease Fees',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1001',
      category: 'Survey, Title, ROW',
      description: 'Access fees (roads)',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1001',
      category: 'Survey, Title, ROW',
      description: 'Temporary Sites (bores, construction)',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1003',
      category: 'Survey, Title, ROW',
      description: 'ROW Agent Fees',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1003',
      category: 'Survey, Title, ROW',
      description: 'Title Agent Fees',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'Preliminary Survey',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'Plats, Alignment Sheets',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'As-Built Survey',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'Biological Survey',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'Archeological Survey',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'Class Location/HCA Study',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1004',
      category: 'Survey, Title, ROW',
      description: 'SWPPP Services',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-1007',
      category: 'Survey, Title, ROW',
      description: 'Misc Permits and Fees',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '',
      category: '',
      description: 'Survey, Title, ROW Total',
      isSummary: true,
    },
    {
      account: '141-01-2001',
      category: 'Materials',
      description: 'Line Pipe',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2001',
      category: 'Materials',
      description: 'Heavy Wall Pipe',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2002',
      category: 'Materials',
      description: 'Segmentable Elbows',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2002',
      category: 'Materials',
      description: 'Mainline Valves',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2002',
      category: 'Materials',
      description: 'Tap Valves',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2002',
      category: 'Materials',
      description: 'Launcher/Receiver Set',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2022',
      category: 'Materials',
      description: 'Cathodic Protection',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2022',
      category: 'Materials',
      description: 'Corrosion Program (Chem Pumps, Coupons)',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2023',
      category: 'Materials',
      description: 'Flow/Pressure Control',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2023',
      category: 'Materials',
      description: 'Water (Hydrotest)',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2041',
      category: 'Materials',
      description: 'Pipeline Markers',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2041',
      category: 'Materials',
      description: 'Line Fill',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-2052',
      category: 'Materials',
      description: 'Freight',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '',
      category: '',
      description: 'Materials Total',
      isSummary: true,
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Mainline Lay Price',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Bore Construction',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Direct Pipe',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Horizontal Directional Drill',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Rock Ditch with Trencher',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Install Trap',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Mainline Valve',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Tap Valves',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Fabrication Launcher',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Foreign Line Crossing',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Construction Mats',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Hot Tap',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Heavy Timber Clearing',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3003',
      category: 'Construction',
      description: 'Open Cut Wetlands & Waterbodies',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3013',
      category: 'Construction',
      description: 'NDE',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3013',
      category: 'Construction',
      description: 'Chemical Treatment',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-3013',
      category: 'Construction',
      description: 'Pipeline Drying',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-4002',
      category: 'Construction',
      description: 'Capitalized Salaries',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-4003',
      category: 'Construction',
      description: 'Capitalized Travel',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-4006',
      category: 'Construction',
      description: 'Engineering Services',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '',
      category: '',
      description: 'Construction Total',
      isSummary: true,
    },

    {
      account: '141-01-4001',
      category: 'Project Management',
      description: 'Inspection Services',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-4004',
      category: 'Project Management',
      description: 'Environmental Services',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '141-01-6002',
      category: 'Project Management',
      description: 'Legal Fees Services',
      pmOverride: '',
      price: '',
      contingencyPercent: '0%',
      costOverridePercent: '0%',
      contingency: '0%',
      contingencyCost: '$',
      taxRate: 'n/a',
      taxCost: 'n/a',
      baseCost: '$',
      totalPrice: '$',
    },
    {
      account: '',
      category: '',
      description: 'Project Management Total',
      isSummary: true,
    },
    {
      account: '',
      category: '',
      description: 'Total Project',
      isSummary: true,
    },
  ]);

  const columnDefs = useMemo(
    () => [
      { headerName: 'Account', field: 'account', width: 140 },
      { headerName: 'Category', field: 'category', width: 180 },
      { headerName: 'Description', field: 'description', width: 230 },
      {
        headerName: 'PM Override',
        field: 'pmOverride',
        editable: true,
        width: 180,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#000' },
      },
      {
        headerName: 'Price',
        field: 'price',
        editable: false,
        width: 100,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: '% Contingency',
        field: 'contingencyPercent',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: '% Cont Override',
        field: 'contOverridePercent',
        editable: true,
        width: 180,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#000' },
      },
      {
        headerName: 'Contingency',
        field: 'contingency',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: 'Contingency Cost',
        field: 'contingencyCost',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: 'Tax Rate',
        field: 'taxRate',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: 'Tax Cost',
        field: 'taxCost',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: 'Base Cost',
        field: 'baseCost',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
      {
        headerName: 'Total Price',
        field: 'totalPrice',
        editable: false,
        width: 180,
        cellStyle: { backgroundColor: '#fff', color: '#000' },
      },
    ],
    []
  );

  return (
    <Box>
      <Typography
        variant="h6"
        mb={2}
        sx={{
          backgroundColor: '#3A5B8A',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        Cost Category Summary
      </Typography>
      <Box sx={{ width: '100%' }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={{
            resizable: true,
            editable: false,
            cellStyle: {
              textAlign: 'left',
              fontSize: '12px',
              padding: '2px',
            },
          }}
          domLayout="autoHeight"
          suppressMovableColumns
          getRowStyle={(params) => {
            if (params.data?.isSummary) {
              return {
                backgroundColor: '#e3f2fd',
                fontWeight: 'bold',
                fontSize: '13px',
                color: '#1e88e5',
                borderTop: '2px solid #90caf9',
                borderBottom: '2px solid #90caf9',
              };
            }
            return {
              fontSize: '12px',
              lineHeight: '1.2',
              padding: '2px 4px',
            };
          }}
        />
      </Box>
    </Box>
  );
};

export default CostCategorySummaryGrid;
